import getCurrentSetStartWorkoutSelector from '../get-current-set'
import getCurrentWorkoutSectionWorkoutExercisesStartWorkoutSelector
  from '../get-current-workout-section-workout-exercises'
import getNextNonEmptyWorkoutSectionStartWorkoutSelect from '../get-next-non-empty-workout-section'
import getNextSetSelect from '../get-next-set'
import getNextWorkoutExerciseSelect from '../get-next-workout-exercise'
import getRoundsWorkoutSectionUtil from '../../../workout-section/model/utils/get-rounds'
import isCircuitWorkoutSectionUtil from '../../../workout-section/model/utils/is-circuit'
import getCurrentWorkoutSectionSelect from '../../../workout-section/redux/selectors/get-current'
import { logUtil } from 'packages/src'
import { createSelector } from 'reselect'

function hasNextSetForCircuit (curWorkoutSection, workoutExercises, curSet) {
  if (!curSet) {
    logUtil('hasNextSetForCircuit')
      .warn(
        'current set does not exist for current workout section: ',
        curWorkoutSection
      )
    return true
  }

  const rounds = getRoundsWorkoutSectionUtil(workoutExercises)
  let roundIndex
  let setIndexInRound

  rounds.find((round, i) => {
    const hasFoundSet = (
      round.find((obj, index) => {
        setIndexInRound = index
        return obj.set === curSet
      })
    )
    if (hasFoundSet) {
      roundIndex = i
      return true
    }
    return false
  })

  const round = rounds[roundIndex]

  if (!round) {
    return false
  }
  // Return true if there is another workout exercise after
  if (setIndexInRound < round.length - 1) {
    return true
  }

  // Return true if there is another round after
  if (roundIndex < rounds.length - 1) {
    return true
  }

  // Return false if there is no round after
  return false
}

const hasNextSetStartWorkoutSelect = createSelector(getNextSetSelect,
  getNextWorkoutExerciseSelect,
  getNextNonEmptyWorkoutSectionStartWorkoutSelect,
  getCurrentWorkoutSectionSelect,
  getCurrentSetStartWorkoutSelector,
  getCurrentWorkoutSectionWorkoutExercisesStartWorkoutSelector(),
  (nextSet, nextWorkoutExercise, nextWorkoutSection, curWorkoutSection, curSet, workoutExercises) => {
    if (isCircuitWorkoutSectionUtil(curWorkoutSection)) {
      return hasNextSetForCircuit(
        curWorkoutSection,
        workoutExercises,
        curSet
      ) || !!nextWorkoutSection
    }
    return (
      !!nextSet || !!nextWorkoutExercise || !!nextWorkoutSection
    )
  }
)

export default hasNextSetStartWorkoutSelect
